export default __webpack_public_path__ + "static/media/Pcv1SelectH1.22f39184.png";